<template>
  <div class="tools01-copy-detail">
    <el-row>
      <el-col>
        <h2>フォーマット一覧</h2>
      </el-col>
    </el-row>
    <FormatList
      :type="0"
      :toolId="copyPageToolId"
      :pageId="copyPageId"
      :buttonName="'コピー'"
      @formatDecide="copyFormatData"
    />
  </div>
</template>

<script>
import FormatList from "@/components/Ui/Tools01/FormatList.vue";

export default {
  components: {
    FormatList,
  },
  props: {
    tool: String,
    toolId: String,
    pageId: String,
    parameter: String,
    copyPageToolId: String,
    copyPageId: String,
  },
  data() {
    return {
      list: [],
      formats: 0,
    };
  },
  computed: {
    rt() {
      return this.$store.getters.rt;
    },
    apiErrorMessage() {
      return this.$store.getters.apiErrorMessage;
    },
  },
  methods: {
    copyFormatData(formatId) {
      //from_* がコピー元（ページコードから解決済み）、それ以外がコピー先
      let params = new URLSearchParams();
      params.append("from_tool_id", this.copyPageToolId);
      params.append("from_site_id", this.copyPageId);
      params.append("from_format_id", formatId);
      params.append("tool_id", this.toolId);
      params.append("site_id", this.pageId);
      this.$axios
        .post(`${this.rt}/l/api/tools01/format/copy`, params)
        .then((response) => {
          console.log(response);
          //新方式は成功時に本文へ status を入れない。
          //CheckUserId だけ旧方式 (HTTP 200 + 本文 status:401) のため、本文に status があればセッション切れ
          if (response.data.status === undefined) {
            this.$store
              .dispatch("tools01/setFormatList")
              .then((response) => {
                console.log(response);
                history.go(-2);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            alert(response.data.message);
            this.$router.push("/login");
          }
        })
        .catch((error) => {
          console.log(error);
          alert(this.getErrorMessage(error));
        });
    },
    getErrorMessage(error) {
      let message = this.apiErrorMessage;
      if (error.response && error.response.data && error.response.data.message) {
        message = error.response.data.message;
      }
      return message;
    },
  },
};
</script>

<style lang="scss" scoped>
.code {
  margin-top: 30px;
  input {
    width: 50%;
  }
}
</style>
